// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  licenceId: __t.u64().primaryKey().name("licence_id"),
  offerId: __t.u64().name("offer_id"),
  seller: __t.identity(),
  buyer: __t.identity(),
  sigKey: __t.string().name("sig_key"),
  systemId: __t.string().name("system_id"),
  scope: __t.string(),
  observedAt: __t.timestamp().name("observed_at"),
  price: __t.i64(),
  at: __t.timestamp(),
});
